import * as React from 'react';

import { isEmpty } from 'lodash';

import useUpcomingAppointments from '../../useUpcomingAppointments';

import ContentLoading from './components/ContentLoading';
import EmptyState from './components/EmptyState';
import AppointmentsListData from './components/AppointmentsListData';

export interface AppointmentsListProps {
  currentDate: Date;
}

const AppointmentsList: React.FC<AppointmentsListProps> = ({ currentDate }) => {
  const { isLoading, upcomingAppointmentsList } = useUpcomingAppointments(currentDate);

  if (isLoading) return <ContentLoading />;

  if (isEmpty(upcomingAppointmentsList)) return <EmptyState />;

  return <AppointmentsListData data={upcomingAppointmentsList} />;
};

export default AppointmentsList;
